// The outside click used to land on a full-screen layer. Closing on pointerdown
// unmounts that layer before the click, and the click then hits the control
// underneath. The pointerdown stays here; the click closes.
export function OverlayScrim({ onDismiss }: { onDismiss: () => void }) {
  return (
    <div
      data-scrim=""
      className="fixed inset-0 z-scrim"
      onPointerDown={(event) => event.stopPropagation()}
      onClick={onDismiss}
    />
  );
}
